const routes = require('routes.js.erb');
const callbackUrl = routes.auth_url({provider: "google_oauth2"});

export default function authorize(){
  gapi.auth2.authorize({
    client_id: gon.googleClientId,
    scope: 'email profile',
    response_type: 'code',
    state: `${location.search.slice(1)}&redirect_to=${location.pathname}`
  }, function(response) {
    if (response && !response.error) {
      // google authentication succeed, now post data to server.
      jQuery.ajax({
        type: 'POST',
        url: callbackUrl,
        data: response,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        success: function(response) {
          try {
            if (new URL(response.redirect_to).origin != gon.baseWebUrl && response.redirect_to) {
              response.redirect_to += ("?token=" + response.jwt);
            }
            window.location = !!response.redirect_to ? response.redirect_to : '/dashboard';
          } catch (err) {
            window.location = !!response.redirect_to ? response.redirect_to : '/dashboard';
          }
        },
        error: function(request){
          let response = request.responseJSON;
          let errors   = response.errors && response.errors.join('\n');
          let redirect = response.metadata && response.metadata.redirect_to;

          if (errors)
            window.localStorage.setItem(
              'flash',
              JSON.stringify({type: 'danger', message: errors})
            );

          if (redirect)
            window.location = redirect;
        }
      });
    } else {
      console.log(response.error)
      // TODO: how to alert the user something went wrong?
    }
  });
}
